import type { StateProps as StateNewProps, StateStatus } from './State';

export type StateKind = StateStatus;

export interface OldStateProps extends Omit<StateNewProps, 'status'> {
  /** @deprecated status를 대신 사용해주세요. */
  kind?: StateKind;
}

export function convertOldStateProps(props: OldStateProps): StateNewProps {
  const { kind, ...restProps } = props;

  return {
    ...restProps,
    status: kind,
  };
}
